<template>
    <div class="wui-user" v-if="user && user.id">
        <router-link :to="'/user/' + (user.id || user.token)" class="base">
            <div class="avatar">
                <img v-if="user.avatar" :src="util.thumb(user.avatar, 200, 240)" :alt="user.name">
            </div>

            <div class="base-other">
                <div class="name">
                    <span>{{user.name}}</span>
                </div>
                <div>
                    <div class="other">
                        <span v-if="user.gender == 1" class="iconfont icon-man"></span>
                        <span v-if="user.gender == 2" class="iconfont icon-woman1"></span>
<!--                        <span class="dot" v-if="user?.age !== 0 && user.gender > 0">·</span>
                        <span class="age" v-if="user.age !== 0">{{user.age}}</span>-->
                        <span class="dot" v-if="user.fromCountry">·</span>
                        <span class="from">{{user.fromCountry}}</span>
                    </div>
                </div>
                <div class="language">
                    <span>{{util.join(user.languages, ' · ')}}</span>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
    export default {
        props: {
            user: Object
        }
    };
</script>

<style>
    .wui-user {
        position: relative;
        margin-top: -15px;
        margin-bottom: 10px;
        background-color: #ffffff;
        border-radius: 15px;
    }
    .wui-user .base {
        display: flex;
        padding: 20px 15px;
    }

    .wui-user .avatar {
        height: 70px;
        width: 70px;
        min-width: 70px;
        margin-right: 12px;
        border-radius: 2px;
        background-color: #f5f5f5;
    }

    .wui-user .avatar img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 2px;
    }

    .wui-user .base-other {
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        overflow: hidden;
    }

    .wui-user .base-other .name {
        font-weight: 600;
        font-size: 20px;
        line-height: 20px;
        color: #111111;
    }

    .wui-user .base-other .other {
        display: inline-flex;
        align-items: center;
        height: 23px;
        padding: 0 5px;
        background: rgba(17, 17, 17, 0.03);
        border-radius: 6px;

        font-size: 12px;
        color: #111111;
    }

    .wui-user .base-other .other .dot {
        padding: 0 4px;
    }

    .wui-user .base-other .other .iconfont {
        font-size: 14px;
        line-height: 1;
        padding-left: 2px;
    }

    .wui-user .base-other .language {
        font-size: 12px;
        line-height: 17px;
        color: #111111;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
